import dynamic from 'next/dynamic';
import loading from '../../lib/fullScreenLoading';

export default dynamic(() => import('.'), {
  ssr: false,
  loading,
});
